export const MARITAL_STATUS_OPTIONS = [
  { value: "未婚", label: "未婚" },
  { value: "已婚", label: "已婚" },
  { value: "离异", label: "离异" },
  { value: "丧偶", label: "丧偶" },
];

export const MARITAL_STATUS_EVENT = "maritalStatusUpdated";

export function isMarriedUser(maritalStatus) {
  return maritalStatus === "已婚";
}

export function isSingleCenterUser(maritalStatus) {
  return !isMarriedUser(maritalStatus);
}

/** 寻找对象页可选的婚姻状况（不含已婚） */
export const SINGLE_DATING_MARITAL_OPTIONS = MARITAL_STATUS_OPTIONS.filter(
  (item) => item.value !== "已婚"
);

export function canAccessSingleDating(maritalStatus) {
  return !isMarriedUser(maritalStatus);
}

export function syncMaritalStatus(maritalStatus) {
  if (maritalStatus) {
    localStorage.setItem("marital_status", maritalStatus);
  } else {
    localStorage.removeItem("marital_status");
  }

  window.dispatchEvent(
    new CustomEvent(MARITAL_STATUS_EVENT, {
      detail: { maritalStatus: maritalStatus || "" },
    })
  );
}

export function getRegisterRedirectPath(maritalStatus) {
  return isMarriedUser(maritalStatus) ? "/center" : "/center/profile";
}

export function getProfileCompleteRedirectPath(maritalStatus, user = {}) {
  if (isMarriedUser(maritalStatus)) {
    return user.has_questionnaire ? "/consultants" : "/questionnaire";
  }

  if (!user.has_questionnaire) {
    return "/questionnaire";
  }

  return "/discover";
}

export function getCenterTitle(maritalStatus) {
  return isMarriedUser(maritalStatus) ? "婚姻中心" : "个人中心";
}

export function getMaritalStatusChangeMessage(prevStatus, nextStatus) {
  if (!prevStatus || !nextStatus || prevStatus === nextStatus) {
    return "";
  }

  if (isMarriedUser(nextStatus) && !isMarriedUser(prevStatus)) {
    return "婚姻状况已更新，已为您切换到婚姻中心";
  }

  if (!isMarriedUser(nextStatus) && isMarriedUser(prevStatus)) {
    return "婚姻状况已更新，已为您切换到个人中心";
  }

  return "婚姻状况已更新，后台展示已同步";
}

/** 仅单身交友后台可访问的路径 */
export const SINGLE_ONLY_CENTER_PATHS = [
  "/center/preview",
  "/center/views",
  "/center/friends",
  "/center/albums",
];
